import React from 'react';
import { connect } from 'react-redux';

import GroupedColumns from './GroupedColumns.jsx';

class DroppableTileList extends React.Component {
  constructor(props) {
    super(props);

    this.columnTiles = this.columnTiles.bind(this);
    this.paginatedColumns = this.paginatedColumns.bind(this);
    this.filteredColumns = this.filteredColumns.bind(this);
  }

  columnTiles(columnId) {
    const { columns, tiles } = this.props.dndContext[this.props.activeStatus];
    const column = columns[columnId];

    if (column) {
      const { tilesIds } = column;

      return tilesIds.map(tileId => {
        return tiles[tileId];
      });
    }

    return [];
  }

  paginatedColumns(tilesPerRow, activeStatus) {
    const defaultPageSize = (tilesPerRow || 4) % 2 === 0 ? 16 : 15;
    const pageSize = this.props.pageSize || defaultPageSize;
    const { pageNumber = 1, dndContext, bucketDate, showAllItems } = this.props;
    const sliceStartIndex = 0;
    const defaultSliceEndIndex = (pageNumber * pageSize) / tilesPerRow;
    const sliceEndIndex = showAllItems ? undefined : defaultSliceEndIndex;
    const bucketRegex = new RegExp(bucketDate);
    return dndContext[activeStatus].columnOrder
      .filter(column => (bucketDate ? bucketRegex.test(column) : true))
      .slice(sliceStartIndex, sliceEndIndex);
  }

  filteredColumns(tilesPerRow, activeStatus) {
    const { columns } = this.props.dndContext[activeStatus];
    return this.paginatedColumns(tilesPerRow, activeStatus)
      .map(columnId => columns[columnId])
      .filter(column => column);
  }

  render() {
    return (
      <GroupedColumns
        columns={this.filteredColumns(
          this.props.tilesPerRow,
          this.props.activeStatus,
        )}
        getTiles={this.columnTiles}
        title="Generic"
        {...this.props}
      />
    );
  }
}

DroppableTileList.defaultProps = {
  showAllItems: false,
};

const mapStateToProps = (state, ownProps) => {
  const tilesPerRow = ownProps.tilesPerRow || state.tilesPerRow;

  return { tilesPerRow };
};

export { DroppableTileList };

export default connect(mapStateToProps)(DroppableTileList);
